import React, { useState } from 'react'
import IntroAnimation from '../../organisms/IntroAnimation/IntroAnimation'
import HeroSection from '../../molecules/RabbitX/HeroSection'
import OverviewSection from '../../molecules/RabbitX/OverviewSection'
import ChallengeSection from '../../molecules/RabbitX/ChallengeSection'
import WhatWeBuiltSection from '../../molecules/RabbitX/WhatWeBuiltSection'
import OutcomeSection from '../../molecules/RabbitX/OutcomeSection'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import colors from '../../theme/color'

const RabbitXPage = () => {
  const [startAnimation, setStartAnimation] = useState(false)

  // 🔥 FORCE RE-MOUNT INTRO EVERY VISIT
  const [introKey] = useState(() => Date.now())

  return (
    <div
      className="relative min-h-screen overflow-hidden text-white"
      style={{
        backgroundImage: `linear-gradient(to bottom, ${colors.rabbitXPageBg}, #0d0620, #070313)`,
      }}
    >
      <IntroAnimation
        key={introKey}
        words={['RABBITX']}
        wordColors={['#f8f8f8', '#ffffff']}
        backgroundGradient={{
          top: '#b63822',
          bottom: '#251614',
        }}
        onHeroStart={() => setStartAnimation(true)}
      />

      <HeroSection />
      <OverviewSection />
      <ChallengeSection />
      <WhatWeBuiltSection />
      <OutcomeSection />

      <Testimonial className="mx-auto mb-20 max-w-[90%]" themeColor="rabbitx" />

      <div className="w-full">
        <div className="mb-10 px-4 md:px-8 mx-2 lg:mx-20 lg:px-12 xl:mx-auto xl:max-w-[1400px] 2xl:max-w-[1800px] 2xl:px-10">
          <div className="grid w-full grid-cols-1 gap-5 lg:grid-cols-[1fr_2fr]">
            <Message themeColor="rabbitx" />
            <Questions themeColor="rabbitx" />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default RabbitXPage